var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tile d-inline-block",class:_vm.tileClass,style:(_vm.tileStyle)},[_c('b-icon',{staticClass:"h-100 w-100",class:_vm.iconClass,attrs:{"icon":_vm.icon}}),(_vm.showStrength)?_c('div',{staticClass:"strength strength-text-size"},[_vm._v(_vm._s(_vm.boardStrength))]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }